import EnterFlowAccountForm from 'components/authentication/EnterFlowAccountForm';
import { FadeIn } from 'components/common/FadeIn';
import { useScrollToElement } from 'hooks/useScrollToElement';
import { useRouter } from 'next/router';
import React, { useRef } from 'react';
import Checkout from '../Checkout';
import MembershipSummary from '../MembershipSummary';
import { MainEnterFlowNavigation, V2NavigationRight } from '../Navigation';
import TitleSection, { InfoGraphicRow } from '../TitleSection';
import V2EnterLayout from './V2EnterLayout';
import { enterFlowSubtitle, enterFlowTitle } from './V2EntriesAndDays';

import styles from './V2CheckoutAndIdentity.module.css';

interface V2CheckoutAndIdentityProps {}

export const V2CheckoutAndIdentity: React.FC<
  V2CheckoutAndIdentityProps
> = ({}) => {
  const router = useRouter();
  const checkoutComponentMarker = useRef<HTMLDivElement>(null);
  const scroller = useScrollToElement(checkoutComponentMarker);

  const login = (
    <EnterFlowAccountForm
      appleRedirectPath={router.pathname}
      completionHandler={async () => {
        checkoutComponentMarker.current &&
          scroller.requestScroll({
            ensureAtTopOfViewport: true,
          });
      }}
    />
  );

  const title = enterFlowTitle(true);
  const subtitle = enterFlowSubtitle(true);

  return (
    <V2EnterLayout
      checkoutPage
      desktopLeft={
        <>
          <MainEnterFlowNavigation />
          <TitleSection title={title} subtitle={subtitle} />
          <FadeIn onScroll>{login}</FadeIn>
          <Checkout />
        </>
      }
      desktopRight={
        <>
          <V2NavigationRight />
          <div className={styles.desktopRightContent}>
            <FadeIn onScroll>
              <InfoGraphicRow desktopVersion />
            </FadeIn>
            <MembershipSummary checkoutPage />
          </div>
        </>
      }
      mobileBottom={
        <>
          {login}
          <div ref={checkoutComponentMarker}></div>
          <Checkout />
        </>
      }
    />
  );
};

export default V2CheckoutAndIdentity;
